type DefaultConfig = {
	[key: string]: {
		English: string;
		default: string;
	};
};

export const defaultVoiceModel = ({
	language,
	provider,
}: {
	language?: string;
	provider?: string;
}): string => {
	const defaults: DefaultConfig = {
		'11labs': {
			English: 'eleven_flash_v2_5',
			default: 'eleven_multilingual_v2',
		},
		deepgram: {
			English: 'aura-asteria-en',
			default: '',
		},
		cartesia: {
			English: 'sonic-2',
			default: 'sonic-2',
		},
		openai: {
			English: 'gpt-4o-mini-tts',
			default: 'gpt-4o-mini-tts',
		},
		rime: {
			English: 'arcana',
			default: 'mistv2',
		},
	};

	return provider ? defaults[provider]?.[language === 'English' ? 'English' : 'default'] || '' : '';
};
